<template>
	<div
	class="salon-en-vivo">
		<salon-en-vivo></salon-en-vivo>
	
		<b-button
		v-if="is_today"
		variant="primary"
		size="lg"
		v-b-modal="'salon-mapa-en-vivo'">
			<img src="@/assets/location.png" alt="">
			Salon en vivo
		</b-button>
	</div>
</template>
<script>
import moment from 'moment'
export default {
	components: {
		SalonEnVivo: () => import('@/components/orders/modals/SalonEnVivo'),
	},
	computed: {
		from_date() {
			return this.$store.state.order.from_date
		},
		is_today() {
			console.log(moment().format('YYYY-MM-DD')+' 00:00:00')
			return this.from_date == moment().format('YYYY-MM-DD') || this.from_date == moment().format('YYYY-MM-DD')+' 00:00:00'
		}
	}
}
</script>
<style lang="sass">
.salon-en-vivo
	img
		width: 30px
</style>